import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { NAV_PATHS } from '../../types/navigation';

/**
 * Sends visitors to Home when authenticated, otherwise to login.
 */
export function RootRedirect(): React.JSX.Element {
  const { isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0B0F]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#EAB308]" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={NAV_PATHS.HOME} replace />;
  }

  return <Navigate to="/auth/login" replace />;
}
